var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Box, Typography, Avatar, Chip, Button, Divider, Dialog, IconButton, Tooltip, CircularProgress, Menu, MenuItem, Tab, Tabs, } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import FavoriteIcon from '@mui/icons-material/Favorite';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import HotelIcon from '@mui/icons-material/Hotel';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import BedIcon from '@mui/icons-material/Bed';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SensorsIcon from '@mui/icons-material/Sensors';
import SnoozeOutlinedIcon from '@mui/icons-material/SnoozeOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import { useAppSelector } from 'hooks/reduxHooks';
import { Roles } from 'globals/enums';
import { isValidAlertTransition, updateAlertStatusService, fetchSeniorAlertsByStatus, VALID_ALERT_TRANSITIONS, ALERT_STATUS, } from './SeniorCard.service';
// State transition rules matching backend matrix
var VALID_TRANSITIONS = {
    ACTIVE: [ALERT_STATUS.ACKNOWLEDGED, ALERT_STATUS.DISMISSED, ALERT_STATUS.RESOLVED],
    ACKNOWLEDGED: [ALERT_STATUS.DISMISSED, ALERT_STATUS.RESOLVED],
    DISMISSED: [ALERT_STATUS.RESOLVED],
    RESOLVED: [ALERT_STATUS.ARCHIVED],
    ARCHIVED: [],
};
// Filter tabs shown on the "All Alerts" popup
var ALERT_FILTER_OPTIONS = [
    ALERT_STATUS.ACTIVE,
    ALERT_STATUS.ACKNOWLEDGED,
    ALERT_STATUS.DISMISSED,
    ALERT_STATUS.RESOLVED,
    ALERT_STATUS.ARCHIVED,
];
var FILTER_LABEL = {
    ACTIVE: 'Active',
    ACKNOWLEDGED: 'Acknowledged',
    DISMISSED: 'Dismissed',
    RESOLVED: 'Resolved',
    ARCHIVED: 'Archived',
};
// Action-verb labels for the status-transition dropdown on each alert row
var ACTION_LABEL = {
    ACTIVE: 'Active',
    ACKNOWLEDGED: 'Acknowledge',
    DISMISSED: 'Dismiss',
    RESOLVED: 'Resolve',
    ARCHIVED: 'Archive',
};
// Color per action — Acknowledge = blue, Dismiss = red, Resolve = green, Archive = grey
var ACTION_COLOR = {
    ACTIVE: '#64748b',
    ACKNOWLEDGED: '#2563eb',
    DISMISSED: '#dc2626',
    RESOLVED: '#16a34a',
    ARCHIVED: '#64748b',
};
// Brand colors shared with the Global Alerts dialog
var BRAND = '#32602F';
var BRAND_DARK = '#244022';
// Severity styling shared with the Global Alerts dialog
var SEVERITY_STYLE = {
    RED: { label: 'HIGH SEVERITY', bar: '#dc2626', chipBg: '#fee2e2', chipColor: '#dc2626' },
    YELLOW: { label: 'MODERATE SEVERITY', bar: '#f59e0b', chipBg: '#fef3c7', chipColor: '#b45309' },
    GREEN: { label: 'LOW SEVERITY', bar: '#16a34a', chipBg: '#dcfce7', chipColor: '#15803d' },
    DEFAULT: { label: 'INFO', bar: '#94a3b8', chipBg: '#f1f5f9', chipColor: '#475569' },
};
var toMoment = function (value) {
    if (value === null || value === undefined || value === '')
        return null;
    if (typeof value === 'number') {
        // seconds vs milliseconds
        return moment(value < 1e11 ? value * 1000 : value);
    }
    var m = moment(value);
    return m.isValid() ? m : null;
};
// "SLEEP_SCORE" -> "Sleep Score"
var formatEnumLabel = function (value) {
    return value
        ? value
            .toLowerCase()
            .split('_')
            .filter(Boolean)
            .map(function (w) { return w[0].toUpperCase() + w.slice(1); })
            .join(' ')
        : '-';
};
var categoryColors = {
    red: '#dc2626',
    yellow: '#f59e0b',
    green: '#16a34a',
    default: '#94a3b8',
};
var getCategoryColor = function (category) {
    return categoryColors[category] || categoryColors.default;
};
var getCategoryBg = function (category) {
    switch ((category || '').toLowerCase()) {
        case 'red':
            return '#fee2e2';
        case 'yellow':
            return '#fef3c7';
        case 'green':
            return '#dcfce7';
        default:
            return '#f1f5f9';
    }
};
var RISK_CONFIG = {
    high: { label: 'HIGH RISK SENIOR', subtitle: 'Immediate attention recommended', bg: '#dc2626', text: '#dc2626' },
    moderate: { label: 'MODERATE RISK SENIOR', subtitle: 'Monitor closely for changes', bg: '#f59e0b', text: '#d97706' },
    stable: { label: 'STABLE SENIOR', subtitle: 'No immediate concerns', bg: '#16a34a', text: '#16a34a' },
    default: { label: 'AWAITING ACTIVATION', subtitle: 'No risk data available yet', bg: '#475569', text: '#475569' },
};
var getAlertLevelColor = function (level) {
    var l = (level || '').toLowerCase();
    if (['high', 'critical', 'red'].includes(l))
        return '#dc2626';
    if (['moderate', 'medium', 'yellow'].includes(l))
        return '#f59e0b';
    if (['low', 'green'].includes(l))
        return '#16a34a';
    if (['informational', 'info'].includes(l))
        return '#64748b';
    return '#64748b';
};
var formatValue = function (value, unit) {
    if (value === null || value === undefined || value === 'N/A' || value === '')
        return '--';
    return unit ? "".concat(value, " ").concat(unit) : value;
};
var formatDuration = function (totalSeconds) {
    if (!totalSeconds && totalSeconds !== 0)
        return '--';
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    return "".concat(hours, "h ").concat(minutes, "m");
};
var IndicatorTile = function (_a) {
    var icon = _a.icon, iconBg = _a.iconBg, label = _a.label, value = _a.value, subtext = _a.subtext;
    return (_jsx(Tooltip, { title: _jsxs(Box, { sx: { py: 0.25 }, children: [_jsx(Typography, { sx: { fontSize: '0.75rem', fontWeight: 700 }, children: label }), _jsx(Typography, { sx: { fontSize: '0.8rem', fontWeight: 800 }, children: value })] }), arrow: true, placement: "top", children: _jsxs(Box, { sx: {
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '14px',
                padding: '16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minWidth: 0,
                minHeight: '128px',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'default',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 10px 20px -5px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.03)',
                    borderColor: '#cbd5e1',
                },
            }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'flex-start', gap: '10px', minWidth: 0 }, children: [_jsx(Box, { sx: {
                                width: 32,
                                height: 32,
                                borderRadius: '10px',
                                backgroundColor: iconBg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }, children: icon }), _jsx(Typography, { sx: {
                                fontSize: '0.76rem',
                                fontWeight: 700,
                                color: '#475569',
                                lineHeight: 1.25,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }, children: label })] }), _jsxs(Box, { sx: { mt: 1.5, minWidth: 0 }, children: [_jsx(Typography, { sx: { fontSize: '1.25rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.1 }, children: value }), subtext && _jsx(Box, { sx: { mt: 0.75 }, children: subtext })] })] }) }));
};
// Compact alert row used in the "Top Alerts" list on the card
var AlertRow = function (_a) {
    var alert = _a.alert;
    var color = getAlertLevelColor((alert === null || alert === void 0 ? void 0 : alert.level) || (alert === null || alert === void 0 ? void 0 : alert.severity) || (alert === null || alert === void 0 ? void 0 : alert.priority));
    var message = (alert === null || alert === void 0 ? void 0 : alert.message) || (alert === null || alert === void 0 ? void 0 : alert.title) || (alert === null || alert === void 0 ? void 0 : alert.rule_name) || 'Alert';
    return (_jsx(Box, { sx: {
            backgroundColor: '#fff5f5',
            border: "1px solid ".concat(color, "33"),
            borderLeft: "4px solid ".concat(color),
            borderRadius: '10px',
            padding: '10px 12px',
        }, children: _jsx(Typography, { sx: {
                fontSize: '0.78rem',
                fontWeight: 400,
                color: '#1e293b',
                lineHeight: 1.3,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
            }, children: message }) }));
};
// Full alert row used inside the "All Alerts" popup (matches the Global Alerts dialog)
var PopupAlertRow = function (_a) {
    var _b, _c;
    var alert = _a.alert, fallbackStatus = _a.fallbackStatus, loading = _a.loading, _d = _a.statusChangeDisabled, statusChangeDisabled = _d === void 0 ? false : _d, onOpenMenu = _a.onOpenMenu;
    var sev = SEVERITY_STYLE[String((_b = alert === null || alert === void 0 ? void 0 : alert.severity) !== null && _b !== void 0 ? _b : '').toUpperCase()] || SEVERITY_STYLE.DEFAULT;
    var readingAt = toMoment(alert === null || alert === void 0 ? void 0 : alert.lastReadingAt);
    var createdAt = toMoment((_c = alert === null || alert === void 0 ? void 0 : alert.createdAt) !== null && _c !== void 0 ? _c : alert === null || alert === void 0 ? void 0 : alert.created_at);
    var status = String((alert === null || alert === void 0 ? void 0 : alert.status) || fallbackStatus).toUpperCase();
    var options = VALID_TRANSITIONS[status] || (VALID_ALERT_TRANSITIONS === null || VALID_ALERT_TRANSITIONS === void 0 ? void 0 : VALID_ALERT_TRANSITIONS[status]) || [];
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            backgroundColor: '#fff',
            border: '1px solid #e2e8f0',
            borderLeft: "6px solid ".concat(sev.bar),
            borderRadius: '12px',
            p: 2,
            mb: 1.5,
            transition: 'box-shadow 0.2s ease',
            '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.08)' },
        }, children: [_jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }, children: [_jsx(Chip, { size: "small", label: sev.label, sx: { height: 20, fontSize: '0.65rem', fontWeight: 700, backgroundColor: sev.chipBg, color: sev.chipColor } }), (alert === null || alert === void 0 ? void 0 : alert.category) && (_jsx(Chip, { size: "small", label: formatEnumLabel(alert.category), sx: { height: 20, fontSize: '0.65rem', fontWeight: 700, backgroundColor: '#ede9fe', color: '#6d28d9' } })), _jsx(Tooltip, { title: readingAt ? "Reading at ".concat(readingAt.format('MMM D, YYYY, h:mm:ss A')) : 'No reading available', arrow: true, placement: "top", children: _jsx(Chip, { size: "small", icon: _jsx(AccessTimeIcon, { sx: { fontSize: '13px !important' } }), label: readingAt ? "Last reading ".concat(readingAt.fromNow()) : 'No recent reading', sx: { height: 20, fontSize: '0.65rem', backgroundColor: '#f1f5f9', color: '#475569', cursor: 'default' } }) })] }), _jsx(Typography, { component: "div", sx: { fontSize: '0.9rem', color: '#1e293b', mt: 0.75 }, children: (alert === null || alert === void 0 ? void 0 : alert.message) || (alert === null || alert === void 0 ? void 0 : alert.title) || (alert === null || alert === void 0 ? void 0 : alert.rule_name) || 'Alert' }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.75, color: '#64748b', fontSize: '0.72rem' }, children: [_jsx(DevicesOtherIcon, { sx: { fontSize: 14 } }), createdAt ? createdAt.format('MMM D, h:mm A') : '-', " \u2022 ", formatEnumLabel(alert === null || alert === void 0 ? void 0 : alert.ruleClassification)] })] }), loading ? (_jsx(CircularProgress, { size: 20, sx: { color: BRAND, mr: 2 } })) : (_jsx(Button, { variant: "outlined", size: "small", onClick: onOpenMenu, disabled: options.length === 0 || statusChangeDisabled, endIcon: _jsx(KeyboardArrowDownIcon, {}), sx: {
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    borderRadius: '8px',
                    color: BRAND,
                    borderColor: BRAND,
                    whiteSpace: 'nowrap',
                    '&:hover': { borderColor: BRAND_DARK, backgroundColor: 'rgba(50,96,47,0.06)' },
                }, children: options.length === 0 ? 'No actions' : 'Change status' }))] }));
};
var SeniorCardExpandedView = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var senior = _a.senior, onViewDetails = _a.onViewDetails, ruleEngineAlerts = _a.ruleEngineAlerts, ruleEngineAlertsLoading = _a.ruleEngineAlertsLoading, ruleEngineAlertsError = _a.ruleEngineAlertsError;
    var role = useAppSelector(function (state) { return state.auth.roleConfig.role; });
    var isStatusChangeDisabled = role === Roles.FACILITY_AGENT;
    var riskKey = ((senior === null || senior === void 0 ? void 0 : senior.risk_category) || 'default').toLowerCase();
    var risk = RISK_CONFIG[riskKey] || RISK_CONFIG.default;
    var watch = (_b = senior === null || senior === void 0 ? void 0 : senior.devices) === null || _b === void 0 ? void 0 : _b.watch;
    var scale = (_c = senior === null || senior === void 0 ? void 0 : senior.devices) === null || _c === void 0 ? void 0 : _c.scale;
    var sleepMat = (_d = senior === null || senior === void 0 ? void 0 : senior.devices) === null || _d === void 0 ? void 0 : _d.sleep_mat;
    var sos = ((_e = senior === null || senior === void 0 ? void 0 : senior.alerts) === null || _e === void 0 ? void 0 : _e.sos) || 0;
    var falls = ((_f = senior === null || senior === void 0 ? void 0 : senior.alerts) === null || _f === void 0 ? void 0 : _f.falls) || 0;
    var deviceStatus = (senior === null || senior === void 0 ? void 0 : senior.device_status) || {};
    var deviceEntries = Object.entries(deviceStatus);
    var onlineCount = deviceEntries.filter(function (_a) {
        var d = _a[1];
        return String((d === null || d === void 0 ? void 0 : d.status) || '-').toLowerCase() === 'online';
    }).length;
    var isConnected = onlineCount > 0;
    var initials = (function () {
        var _a;
        if (!(senior === null || senior === void 0 ? void 0 : senior.seniorName))
            return '?';
        var parts = senior.seniorName
            .trim()
            .split(' ')
            .filter(function (p) { return p && !p.startsWith('('); });
        if (parts.length === 0)
            return '?';
        if (parts.length === 1)
            return ((_a = parts[0][0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '?';
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    })();
    var _j = useState(ruleEngineAlerts || []), localAlerts = _j[0], setLocalAlerts = _j[1];
    var _k = useState(false), showAllAlerts = _k[0], setShowAllAlerts = _k[1];
    var _l = useState(null), actionLoadingId = _l[0], setActionLoadingId = _l[1];
    var _m = useState(null), actionLoadingType = _m[0], setActionLoadingType = _m[1];
    var _o = useState(ALERT_STATUS.ACTIVE), alertStatusFilter = _o[0], setAlertStatusFilter = _o[1];
    var _p = useState(false), alertsFilterLoading = _p[0], setAlertsFilterLoading = _p[1];
    // Alert counts for every status (so the header total isn't tied to the selected tab)
    var _q = useState(null), statusCounts = _q[0], setStatusCounts = _q[1];
    var _r = useState(0), countsReloadKey = _r[0], setCountsReloadKey = _r[1];
    // Change-status menu state
    var _s = useState(null), menuAnchor = _s[0], setMenuAnchor = _s[1];
    var _t = useState(null), menuAlert = _t[0], setMenuAlert = _t[1];
    var closeMenu = function () {
        setMenuAnchor(null);
        setMenuAlert(null);
    };
    var menuStatus = ((menuAlert === null || menuAlert === void 0 ? void 0 : menuAlert.status) || alertStatusFilter || ALERT_STATUS.ACTIVE).toUpperCase();
    var menuOptions = menuAlert
        ? VALID_TRANSITIONS[menuStatus] || (VALID_ALERT_TRANSITIONS === null || VALID_ALERT_TRANSITIONS === void 0 ? void 0 : VALID_ALERT_TRANSITIONS[menuStatus]) || []
        : [];
    useEffect(function () {
        setLocalAlerts(ruleEngineAlerts || []);
    }, [ruleEngineAlerts]);
    useEffect(function () {
        if (!showAllAlerts || !(senior === null || senior === void 0 ? void 0 : senior.seniorId))
            return;
        var cancelled = false;
        setAlertsFilterLoading(true);
        fetchSeniorAlertsByStatus(senior.seniorId, alertStatusFilter)
            .then(function (data) {
            if (!cancelled)
                setLocalAlerts(data);
        })
            .catch(function () {
            // Retain current items on error
        })
            .finally(function () {
            if (!cancelled)
                setAlertsFilterLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [showAllAlerts, alertStatusFilter, senior === null || senior === void 0 ? void 0 : senior.seniorId]);
    // Fetch counts for all statuses whenever the popup opens or an alert changes status
    useEffect(function () {
        if (!showAllAlerts || !(senior === null || senior === void 0 ? void 0 : senior.seniorId))
            return;
        var cancelled = false;
        Promise.all(ALERT_FILTER_OPTIONS.map(function (status) {
            return fetchSeniorAlertsByStatus(senior.seniorId, status)
                .then(function (data) { var _a; return [status, (_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0]; })
                .catch(function () { return [status, undefined]; });
        })).then(function (entries) {
            if (cancelled)
                return;
            var counts = {};
            entries.forEach(function (_a) {
                var status = _a[0], count = _a[1];
                if (count !== undefined)
                    counts[status] = count;
            });
            setStatusCounts(counts);
        });
        return function () {
            cancelled = true;
        };
    }, [showAllAlerts, senior === null || senior === void 0 ? void 0 : senior.seniorId, countsReloadKey]);
    var totalAlertCount = statusCounts
        ? Object.values(statusCounts).reduce(function (sum, n) { return sum + (n || 0); }, 0)
        : localAlerts.length;
    var getAlertId = function (alert) { var _a, _b; return (_b = (_a = alert === null || alert === void 0 ? void 0 : alert.id) !== null && _a !== void 0 ? _a : alert === null || alert === void 0 ? void 0 : alert.alertId) !== null && _b !== void 0 ? _b : alert === null || alert === void 0 ? void 0 : alert.alert_id; };
    var handleUpdateStatus = function (alert, targetStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var alertId, currentStatus, refreshed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isStatusChangeDisabled)
                        return [2 /*return*/];
                    alertId = getAlertId(alert);
                    if (alertId === undefined || alertId === null)
                        return [2 /*return*/];
                    currentStatus = ((alert === null || alert === void 0 ? void 0 : alert.status) || alertStatusFilter || ALERT_STATUS.ACTIVE).toUpperCase();
                    if (!isValidAlertTransition(currentStatus, targetStatus)) {
                        return [2 /*return*/];
                    }
                    setActionLoadingId(alertId);
                    setActionLoadingType(targetStatus);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, updateAlertStatusService(alertId, targetStatus)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, fetchSeniorAlertsByStatus(senior === null || senior === void 0 ? void 0 : senior.seniorId, alertStatusFilter)];
                case 3:
                    refreshed = _b.sent();
                    setLocalAlerts(refreshed);
                    setCountsReloadKey(function (k) { return k + 1; });
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setActionLoadingId(null);
                    setActionLoadingType(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var topAlerts = localAlerts.slice(0, 3);
    var remainingCount = Math.max(localAlerts.length - 3, 0);
    return (_jsxs(Box, { sx: {
            width: '100%',
            maxWidth: '920px',
            borderRadius: '16px',
            overflow: 'hidden',
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            boxSizing: 'border-box',
            fontFamily: 'Inter, sans-serif',
        }, children: [_jsxs(Box, { sx: {
                    backgroundColor: risk.bg,
                    color: '#ffffff',
                    padding: '12px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                }, children: [_jsx(WarningAmberIcon, { sx: { fontSize: 22, flexShrink: 0 } }), _jsx(Typography, { sx: { fontSize: '0.88rem', fontWeight: 800, letterSpacing: '0.02em', whiteSpace: 'nowrap' }, children: risk.label }), _jsxs(Typography, { sx: { fontSize: '0.8rem', opacity: 0.9, fontWeight: 400, display: { xs: 'none', sm: 'block' } }, children: ["| ", risk.subtitle] })] }), _jsxs(Box, { sx: { padding: { xs: '16px', sm: '24px' } }, children: [_jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: 2,
                            mb: 3,
                            pb: 2,
                            borderBottom: '1px solid #e2e8f0',
                        }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }, children: [_jsx(Avatar, { src: ((_g = senior === null || senior === void 0 ? void 0 : senior.profile) === null || _g === void 0 ? void 0 : _g.image) || undefined, sx: { width: 50, height: 50, backgroundColor: '#4f46e5', fontWeight: 700, fontSize: '1.1rem' }, children: !((_h = senior === null || senior === void 0 ? void 0 : senior.profile) === null || _h === void 0 ? void 0 : _h.image) && initials }), _jsx(Box, { sx: { minWidth: 0 }, children: _jsx(Typography, { sx: { fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }, children: (senior === null || senior === void 0 ? void 0 : senior.seniorName) || 'Unknown Senior' }) })] }), _jsx(Chip, { icon: _jsx(SensorsIcon, { sx: { fontSize: '14px !important', color: "".concat(isConnected ? '#16a34a' : '#dc2626', " !important") } }), label: isConnected ? 'Live' : 'Offline', size: "small", sx: {
                                    backgroundColor: isConnected ? '#f0fdf4' : '#fef2f2',
                                    color: isConnected ? '#16a34a' : '#dc2626',
                                    border: "1px solid ".concat(isConnected ? '#bbf7d0' : '#fecaca'),
                                    fontWeight: 700,
                                    fontSize: '0.7rem',
                                    height: '24px',
                                } })] }), _jsxs(Box, { sx: { display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: '20px' }, children: [_jsxs(Box, { sx: { minWidth: 0 }, children: [_jsx(Typography, { sx: { fontSize: '0.72rem', fontWeight: 800, color: '#64748b', letterSpacing: '0.08em', mb: 1.5 }, children: "KEY HEALTH INDICATORS" }), _jsxs(Box, { sx: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '14px' }, children: [_jsx(IndicatorTile, { icon: _jsx(FavoriteIcon, { sx: { fontSize: 18, color: getCategoryColor(watch === null || watch === void 0 ? void 0 : watch.heart_category) } }), iconBg: getCategoryBg(watch === null || watch === void 0 ? void 0 : watch.heart_category), label: "Heart Rate", value: formatValue(watch === null || watch === void 0 ? void 0 : watch.heart_rate, (watch === null || watch === void 0 ? void 0 : watch.heart_rate) ? 'bpm' : undefined) }), _jsx(IndicatorTile, { icon: _jsx(DirectionsWalkIcon, { sx: { fontSize: 18, color: getCategoryColor(watch === null || watch === void 0 ? void 0 : watch.activity_category) } }), iconBg: getCategoryBg(watch === null || watch === void 0 ? void 0 : watch.activity_category), label: "Activity Score", value: formatValue(watch === null || watch === void 0 ? void 0 : watch.avg_activity_score) }), _jsx(IndicatorTile, { icon: _jsx(WarningAmberIcon, { sx: { fontSize: 18, color: sos + falls > 0 ? '#dc2626' : '#94a3b8' } }), iconBg: sos + falls > 0 ? '#fee2e2' : '#f1f5f9', label: "SOS / Falls", value: "".concat(sos, "/").concat(falls) }), _jsx(IndicatorTile, { icon: _jsx(MonitorWeightIcon, { sx: { fontSize: 18, color: getCategoryColor(scale === null || scale === void 0 ? void 0 : scale.weight_category) } }), iconBg: getCategoryBg(scale === null || scale === void 0 ? void 0 : scale.weight_category), label: "Weight", value: formatValue(scale === null || scale === void 0 ? void 0 : scale.avg_weight, (scale === null || scale === void 0 ? void 0 : scale.avg_weight) ? 'lbs' : undefined) }), _jsx(IndicatorTile, { icon: _jsx(WaterDropIcon, { sx: { fontSize: 18, color: getCategoryColor(scale === null || scale === void 0 ? void 0 : scale.hydration_category) } }), iconBg: getCategoryBg(scale === null || scale === void 0 ? void 0 : scale.hydration_category), label: "Hydration", value: formatValue(scale === null || scale === void 0 ? void 0 : scale.avg_hydration, (scale === null || scale === void 0 ? void 0 : scale.avg_hydration) ? '%' : undefined) }), _jsx(IndicatorTile, { icon: _jsx(HotelIcon, { sx: { fontSize: 18, color: getCategoryColor(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.sleep_category) } }), iconBg: getCategoryBg(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.sleep_category), label: "Sleep Score", value: formatValue(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.avg_sleep_score) }), _jsx(IndicatorTile, { icon: _jsx(SnoozeOutlinedIcon, { sx: { fontSize: 18, color: getCategoryColor(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.sleep_category) } }), iconBg: getCategoryBg(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.sleep_category), label: "Interruptions", value: formatValue(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.interruptions) }), _jsx(IndicatorTile, { icon: _jsx(BedIcon, { sx: { fontSize: 18, color: '#4f46e5' } }), iconBg: "#e0e7ff", label: "Sleep Duration", value: formatDuration(sleepMat === null || sleepMat === void 0 ? void 0 : sleepMat.avg_total_sleep_time) })] })] }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '16px', minWidth: 0 }, children: [_jsxs(Box, { onClick: function (e) { return e.stopPropagation(); }, sx: {
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #fee2e2',
                                            borderRadius: '14px',
                                            padding: '16px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                                        }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }, children: [_jsx(NotificationsIcon, { sx: { fontSize: 18, color: '#dc2626' } }), _jsxs(Typography, { sx: { fontSize: '0.75rem', fontWeight: 800, color: '#dc2626', letterSpacing: '0.04em' }, children: ["TOP ALERTS (", localAlerts.length, ")"] })] }), ruleEngineAlertsLoading ? (_jsx(Typography, { sx: { fontSize: '0.72rem', color: '#64748b', fontStyle: 'italic' }, children: "Loading alerts\u2026" })) : localAlerts.length === 0 ? (_jsxs(Typography, { sx: { fontSize: '0.72rem', color: '#64748b', fontStyle: 'italic' }, children: ["No active alerts", ruleEngineAlertsError ? ' (alerts unavailable)' : ''] })) : (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '8px' }, children: [topAlerts.map(function (alert, idx) {
                                                        var _a;
                                                        return (_jsx(Box, { onClick: function () { return setShowAllAlerts(true); }, sx: { cursor: 'pointer' }, children: _jsx(AlertRow, { alert: alert }) }, (_a = getAlertId(alert)) !== null && _a !== void 0 ? _a : idx));
                                                    }), _jsx(Button, { onClick: function (e) {
                                                            e.stopPropagation();
                                                            setShowAllAlerts(true);
                                                        }, sx: {
                                                            alignSelf: 'flex-start',
                                                            textTransform: 'none',
                                                            fontSize: '0.72rem',
                                                            fontWeight: 700,
                                                            color: '#4f46e5',
                                                            p: 0,
                                                            minWidth: 0,
                                                            mt: 0.5,
                                                        }, children: remainingCount > 0 ? "Show ".concat(remainingCount, " more") : 'Manage alerts' })] }))] }), _jsxs(Box, { sx: {
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '14px',
                                            padding: '16px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                                        }, children: [_jsx(Typography, { sx: { fontSize: '0.72rem', fontWeight: 800, color: '#64748b', letterSpacing: '0.08em', mb: 1.5 }, children: "OVERVIEW" }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '8px' }, children: [_jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Typography, { sx: { fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }, children: "Risk Level" }), _jsx(Typography, { sx: { fontSize: '0.75rem', color: risk.text, fontWeight: 800, textTransform: 'capitalize' }, children: (senior === null || senior === void 0 ? void 0 : senior.risk_category) || 'None' })] }), _jsx(Divider, { sx: { borderColor: '#f1f5f9' } }), _jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Typography, { sx: { fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }, children: "Alert Count" }), _jsx(Typography, { sx: { fontSize: '0.75rem', color: '#0f172a', fontWeight: 800 }, children: localAlerts.length })] }), _jsx(Divider, { sx: { borderColor: '#f1f5f9' } }), _jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Typography, { sx: { fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }, children: "Status" }), _jsx(Typography, { sx: { fontSize: '0.75rem', color: isConnected ? '#16a34a' : '#dc2626', fontWeight: 700 }, children: isConnected ? 'Active' : 'Inactive' })] })] })] }), _jsx(Button, { variant: "contained", disableElevation: true, fullWidth: true, onClick: onViewDetails, sx: {
                                            backgroundColor: '#4f46e5',
                                            color: '#ffffff',
                                            fontWeight: 700,
                                            fontSize: '0.8rem',
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            py: 1.2,
                                            '&:hover': { backgroundColor: '#4338ca' },
                                        }, children: "View Senior Details" })] })] })] }), _jsxs(Dialog, { open: showAllAlerts, onClose: function (e) {
                    var _a;
                    (_a = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(e);
                    setShowAllAlerts(false);
                }, onClick: function (e) { return e.stopPropagation(); }, fullWidth: true, maxWidth: "md", PaperProps: {
                    sx: {
                        borderRadius: '20px',
                        overflow: 'hidden',
                        backgroundColor: '#f8fafc',
                        height: { xs: '92vh', md: '75vh' },
                        maxHeight: 760,
                    },
                }, children: [_jsxs(Box, { sx: {
                            backgroundColor: BRAND,
                            color: '#fff',
                            px: 3,
                            py: 1.25,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2,
                        }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'baseline', gap: 1.25, minWidth: 0, flexWrap: 'wrap' }, children: [_jsx(Typography, { component: "h2", noWrap: true, sx: { fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.3, maxWidth: '100%' }, children: (senior === null || senior === void 0 ? void 0 : senior.seniorName) || 'Senior' }), _jsx(Typography, { component: "span", sx: { fontSize: '0.85rem', opacity: 0.6, lineHeight: 1.3 }, children: "|" }), _jsxs(Typography, { component: "span", sx: { fontSize: '0.85rem', fontWeight: 500, opacity: 0.9, lineHeight: 1.3 }, children: ["All Alerts (", totalAlertCount, ")"] })] }), _jsx(IconButton, { size: "small", onClick: function () { return setShowAllAlerts(false); }, "aria-label": "Close", sx: {
                                    color: '#fff',
                                    backgroundColor: 'rgba(0,0,0,0.2)',
                                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.35)' },
                                }, children: _jsx(CloseIcon, { fontSize: "small" }) })] }), _jsxs(Box, { sx: { px: 3, pt: 2.5, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }, children: [_jsx(Tabs, { value: alertStatusFilter, onChange: function (_, v) { return setAlertStatusFilter(v); }, variant: "fullWidth", TabIndicatorProps: { style: { display: 'none' } }, sx: {
                                    backgroundColor: '#e2e8f0',
                                    borderRadius: '50px',
                                    p: '4px',
                                    minHeight: 44,
                                    flexShrink: 0,
                                    '& .MuiTab-root': {
                                        minHeight: 36,
                                        borderRadius: '50px',
                                        textTransform: 'none',
                                        fontSize: '0.78rem',
                                        fontWeight: 700,
                                        color: '#64748b',
                                        transition: 'all 0.2s ease',
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: '#fff',
                                        color: "".concat(BRAND_DARK, " !important"),
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                    },
                                }, children: ALERT_FILTER_OPTIONS.map(function (status) { return (_jsx(Tab, { value: status, label: (statusCounts === null || statusCounts === void 0 ? void 0 : statusCounts[status]) !== undefined
                                        ? "".concat(FILTER_LABEL[status], " (").concat(statusCounts[status], ")")
                                        : FILTER_LABEL[status] }, status)); }) }), _jsx(Box, { sx: { flex: 1, overflowY: 'auto', pr: 0.5, py: 2 }, children: alertsFilterLoading ? (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8 }, children: [_jsx(CircularProgress, { size: 36, sx: { color: BRAND } }), _jsx(Typography, { component: "div", sx: { mt: 2, color: '#64748b', fontSize: '0.85rem' }, children: "Loading alerts..." })] })) : localAlerts.length === 0 ? (_jsx(Box, { sx: {
                                        textAlign: 'center',
                                        color: '#64748b',
                                        py: 8,
                                        backgroundColor: '#fff',
                                        borderRadius: '12px',
                                        border: '1px solid #e2e8f0',
                                    }, children: _jsxs(Typography, { sx: { fontWeight: 600 }, children: ["No ", FILTER_LABEL[alertStatusFilter].toLowerCase(), " alerts"] }) })) : (localAlerts.map(function (alert, idx) {
                                    var alertId = getAlertId(alert);
                                    return (_jsx(PopupAlertRow, { alert: alert, fallbackStatus: alertStatusFilter, statusChangeDisabled: isStatusChangeDisabled, loading: actionLoadingId === alertId && !!actionLoadingType, onOpenMenu: function (e) {
                                            setMenuAnchor(e.currentTarget);
                                            setMenuAlert(alert);
                                        } }, alertId !== null && alertId !== void 0 ? alertId : idx));
                                })) })] }), _jsx(Menu, { anchorEl: menuAnchor, open: Boolean(menuAnchor), onClose: closeMenu, children: menuOptions.map(function (status) { return (_jsxs(MenuItem, { dense: true, onClick: function () {
                                var alert = menuAlert;
                                closeMenu();
                                if (alert)
                                    handleUpdateStatus(alert, status);
                            }, sx: { fontSize: '0.8rem', color: ACTION_COLOR[status] }, children: [_jsx(Box, { sx: {
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        backgroundColor: ACTION_COLOR[status],
                                        display: 'inline-block',
                                        mr: 1,
                                        flexShrink: 0,
                                    } }), ACTION_LABEL[status]] }, status)); }) })] })] }));
};
export default SeniorCardExpandedView;
